"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    propertyId: zod_1.z.number(),
});
exports.path = '/admin-get-property-with-permissions';
//# sourceMappingURL=index.js.map